const supportedLocales = {
    en: {
        name: "English (US)",
        nativeName: "English (US)"
    }
}

export default supportedLocales;